import { METHOD } from "../../consts";
import { axiosClient } from "../../service"
import { REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_CONTEXT_SURVEYOR, REACT_APP_VAM_ENDPOINT } from "../../urls"
import { validateEmail, validatePAN } from "../../utilFunctions";
import { validateRequiredDocuments } from "../vendorMaster/helper";

const getDocumentURLs = async (data, docUrls, requiredUploadDocumentsList, setDocUrls) => {
    let updatedUrls = { ...docUrls }
    requiredUploadDocumentsList.map(async document => {
        if (data[document.key]?.docID) {
            axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}`)({ url: `${data[document.key]?.docID}`, method: METHOD.GET }).then(urlData => {
                setDocUrls(prev => ({ ...prev, [document.key]: urlData.data.docURL }))
            })
        }
    })
    setDocUrls(updatedUrls)
}

export const defaultSurveryorFileData = {
    docID : 0,
    docName : null,
    docType : null,
    docURL : null,
    fileType : null,
    isFileLoading: false
}

const getParsedFileDate = (stringifiedFileData) => {
    try {
        return JSON.parse(stringifiedFileData)
    } catch(error) {
        console.error(error)
        return defaultSurveryorFileData
    }
}

export const getSurveyorData = (getDistrictList, getDistrictAllocationList, getMandalList, getMandalAllocationList, getVillageList, setCreateSurveyorData, docUrls, requiredUploadDocumentsList, setDocUrls) => {
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}`)({ url: `getSurveyor/${localStorage.getItem("SurveyorId")}`, method: METHOD.GET }).then(data => {
        const surveyorData = { ...data.data }
        const modifiedData = {
            ...surveyorData,
            "panCard": getParsedFileDate(surveyorData.panCard),
            "aadhaarCard": getParsedFileDate(surveyorData.aadhaarCard),
            "isslaOrLicenseByIRDAI": getParsedFileDate(surveyorData.isslaOrLicenseByIRDAI),
        }
        getDocumentURLs(modifiedData, docUrls, requiredUploadDocumentsList, setDocUrls)
        getDistrictList(surveyorData.state)
        getDistrictAllocationList(surveyorData.stateForAllocationDetails)
        getMandalList(surveyorData.district, surveyorData.state)
        getMandalAllocationList(surveyorData.districtForAllocationDetails, surveyorData.stateForAllocationDetails)
        getVillageList(surveyorData.mandal, surveyorData.district, surveyorData.state)
        setCreateSurveyorData(modifiedData)
    }).catch(error => {
        console.error(error)
    })
}

function validateObject(surveyorDetails) {
    const optionalFields = ['email', 'panNumber', 'mandal', 'village', 'product', 'tehsilOrMandal', 'pancard', 'isslaOrLicenseByIRDAI'];
    // remaining all fields are mandatory
    for (let key in surveyorDetails) {
        // if field is undefined or null  or  '' and field is in optional fields array, continue the loop and check the next key
        if (surveyorDetails[key] === undefined || surveyorDetails[key] === null || surveyorDetails[key] === '') {
            if (optionalFields.includes(key)) {
                continue;
            }
            return false;
        }
    }
    return true;
}

export const createSurvyorMaster = (createSurvyorData, toast, cancelCreateSurvyorMaster) => {
    if (!validateObject(createSurvyorData) || !validateRequiredDocuments(createSurvyorData.aadhaarCard)) {
        toast.error("Please Fill All Required Fields")
        return
    }
    if (createSurvyorData.panNumber && !validatePAN(createSurvyorData.panNumber)) {
        toast.error("Please Enter Valid PAN Number.")
        return
    }
    if(createSurvyorData.email&&!validateEmail(createSurvyorData.email)) {
            toast.error("Please Enter Valid Email.")
            return
        }
    if (createSurvyorData.mobileNumber.length !== 10) {
        toast.error("Please Enter Valid Mobile Number.")
        return
    }
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}`)({
        url: `${localStorage.getItem("SurveyorId") ? 'updateSurveyorAndQCMaster' : 'saveSurveyorAndQCMasterCreation'}`,
        method: METHOD.POST,
        data: {
            ...createSurvyorData,
            "panCard": JSON.stringify(createSurvyorData.panCard),
            "aadhaarCard": JSON.stringify(createSurvyorData.aadhaarCard),
            "isslaOrLicenseByIRDAI": JSON.stringify(createSurvyorData.isslaOrLicenseByIRDAI),
        }
    }).then(data => {
        // axiosSimple().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}/${localStorage.getItem("SurveyorId") ? 'updateSurveyorAndQCMaster' : 'saveSurveyorAndQCMasterCreation'}`, {
        //     ...createSurvyorData,
        //     "panCard": JSON.stringify(createSurvyorData.panCard),
        //     "aadhaarCard": JSON.stringify(createSurvyorData.aadhaarCard),
        //     "isslaOrLicenseByIRDAI": JSON.stringify(createSurvyorData.isslaOrLicenseByIRDAI),
        // }).then(data => {
        toast.success(data.data.message)
        cancelCreateSurvyorMaster()
    }).catch(error => {
        console.log(error)
    })
}